import React from 'react';
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import { useTranslation } from 'react-i18next';
import { ThemeProvider, createTheme, Direction } from '@mui/material/styles';

const DirectionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { i18n } = useTranslation();
  const direction = i18n.dir();

  React.useEffect(() => {
    const updateDirection = (dir: string) => {
      document.dir = dir;
      document.body.dir = dir;
      // שפת הדף לקוראי מסך - he או en
      document.documentElement.lang = i18n.resolvedLanguage || i18n.language;
      document.documentElement.style.setProperty('--dir', dir);
    };

    // הגדרה ראשונית
    updateDirection(direction);

    // האזנה לשינויי שפה
    const handleLanguageChange = () => {
      const newDirection = i18n.dir();
      updateDirection(newDirection);
    };

    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n, direction]);

  const cache = createCache({
    key: `mui-${direction}`,
    stylisPlugins: direction === 'rtl' ? [prefixer, rtlPlugin] : [prefixer],
  });

  const theme = createTheme({ direction: direction as Direction });

  return (
    <CacheProvider value={cache}>
      <ThemeProvider theme={theme}>
        {children}
      </ThemeProvider>
    </CacheProvider>
  );
};

export default DirectionProvider;